// Feature flags — controlados por variables de entorno del frontend.
// Para reactivar los pagos: poner REACT_APP_PAYMENTS_ENABLED=true en frontend/.env
// (y en las env vars de producción al deployar) — el código de pagos queda intacto.
export const PAYMENTS_ENABLED = process.env.REACT_APP_PAYMENTS_ENABLED === 'true';
// Para reactivar referidos: poner REACT_APP_REFERRALS_ENABLED=true en frontend/.env
export const REFERRALS_ENABLED = process.env.REACT_APP_REFERRALS_ENABLED === 'true';
